'use client';

import { useEffect } from 'react';
import { useReportWebVitals } from 'next/web-vitals';
import { initErrorMonitoring, queueVital } from '@/lib/telemetry';

// Rendert niets; koppelt Web Vitals-rapportage en globale error handlers
// aan de pagina. Zit in de root layout zodat elke route gedekt is.
export function Observability() {
  useEffect(() => {
    initErrorMonitoring();
  }, []);
  useReportWebVitals(queueVital);
  return null;
}
